<template>
  <!-- 不記名投票票數輸入區塊 -->
  <div id="NotRecordNameWriteVotes_main">
    <div
      class="main"
      :class="{'logoutInfoShow' : logoutInfoShow}"
    >
      <div class="optionGroup">
        <div
          v-for="(item, index) in options"
          :key="index"
          class="option"
          :class="classCallback(item.content)"
        >
          <div class="title">
            {{ item.content }}
          </div>
          <el-input-number
            v-model="item.votesNumber"
            :min="0"
            onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 190 ||  event.keyCode == 110 ? false : true" @change="voteChange(index)"
          />
          <div class="txt">
            票
          </div>
        </div>
      </div>
      <el-button
        class="submitButton"
        round
        @click="submit"
      >
        同步票數
      </el-button>
      <div class="tip">
        <span>票數輸入完成之後，請點選右方</span>
        <span class="bold"> 同步票數 </span>
        <span>將最新票數同步至上方儀表板</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Array, // 投票資訊
    tabletValue: Number // 已報到總戶數
  },
  data () {
    return {
      options: [],
      timer: null,
      logoutInfoShow: false
    }
  },
  watch: {
    data: {
      handler (newVal, oldVal) {
        console.log(newVal)
        this.options = newVal
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    // eslint-disable-next-line eqeqeq
    this.logoutInfoShow = (document.getElementById('validation_expired').style.display == '')
    // 監聽自動登出視窗有無出現
    this.timer = setInterval(() => {
      // eslint-disable-next-line eqeqeq
      this.logoutInfoShow = (document.getElementById('validation_expired').style.display == '')
    }, 5000)
  },
  methods: {
    voteChange (index) {
      const obj = this.options[index]
      this.$set(this.options, index, obj)
      // eslint-disable-next-line eqeqeq
      if (obj.votesNumber == '' || obj.votesNumber == undefined) {
        obj.votesNumber = 0
        this.options[index].votesNumber = 0
      }
    },
    submit () {
      // 判斷輸入資料是否合法
      let total = 0
      let errorVotesNumber = 0
      this.options.forEach(item => {
        if (RegExp('^([0-9]*)$').test(item.votesNumber)) {
          item.error = true
        } else {
          errorVotesNumber++
          item.error = false
        }
        total += item.votesNumber
      })
      if (errorVotesNumber > 0) {
        this.$message.error('請輸入正確票數格式')
        return
      }
      console.log(total)
      if (total > this.tabletValue) {
        this.$alert('投票數超過出席戶數，請重新輸入', '錯誤', {
          confirmButtonText: '確定',
          type: 'warning',
          callback: action => {}
        })
      } else {
        this.setVotes()
      }
    },
    // 送出同步票數
    setVotes () {
      const newArray = []
      this.options.forEach(item => {
        newArray.push({
          optionId: item.id,
          votesNumber: item.votesNumber
        })
      })
      apiUnitOwnerAssembly.Vote.SetVotes(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId,
          options: newArray
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$message.success('同步票數成功')
          this.$emit('refresh')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) { this.$message.error(err.response.data.description) }
      })
    },
    classCallback (title) {
      return ['agreeVote', 'disagreeVote', 'invalidTicket'][['同意', '反對', '廢票'].indexOf(title)]
    },
    // 關閉監聽器
    clearInterval () {
      console.log('關閉監聽器')
      clearInterval(this.timer)
    }
  }
}
</script>
<style lang='sass' scoped>
#NotRecordNameWriteVotes_main
  .main
    background-color: $white
    width: 100%
    height: 110px
    position: fixed
    bottom: 0
    left: 0
    z-index: 97
    border-top: 1px $bgDarkBg solid
    padding-top: 19px
    text-align: center
    &.logoutInfoShow
      padding-right: 250px
      box-sizing: border-box
    .optionGroup
      width: 720px
      display: inline-flex
      .option
        flex: 1
        width: 217px
        &.agreeVote
          color: $mainColor
          padding-right: 16px
          border-right: 1px $borderDark1 solid
        &.disagreeVote
          color: $dangerColorDark
          padding-right: 16px
          border-right: 1px $borderDark1 solid
        .title
          margin-left: 23px
          vertical-align: middle
          line-height: 40px
          font-size: 21px
          display: inline-block
          font-weight: 600
        ::v-deep .el-input-number
          vertical-align: middle
          display: inline-block
          margin: 0 12px 0 8px
          width: 120px
          .el-input-number__decrease,.el-input-number__increase
            display: none
          .el-input
            .el-input__inner
              text-align: left
              font-size: 15px
              padding-right: 0
              padding-left: 16px
        .txt
          color: $mainFontColor
          display: inline-block
          font-size: 21px
          line-height: 40px
          vertical-align: middle
    .submitButton
      margin-left: 30px
      display: inline-flex
      border-color: $mainColor
      color: $mainColor
    .tip
      line-height: 24px
      margin-top: 14px
      font-size: 17px
      color: $hintColor
      .bold
        font-weight: 600
</style>
